module.exports = __webpack_public_path__ + "img/5-3.d3f328d5.png";